import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to the top whenever the route changes.
 *
 * React Router does not do this by default — without it, navigating from
 * a long Home (scrolled near the bottom) into a Drill leaves the new
 * page's viewport already scrolled past its header. Mobile users see the
 * middle of the new page first, which feels broken.
 *
 * Render once inside the Router. Hash-only changes (e.g. "#how-it-works"
 * on the marketing page) are preserved — only pathname changes scroll.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use auto, not smooth — instant feels right when crossing a route.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
